import React, { useEffect, useState, useRef } from "react";
import { getAllBanner } from "../apis/authApi";

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const intervalRef = useRef(null);
  const [slides, setSlides] = useState([]);
  const [mainSlide, setMainSlide] = useState(null);

  useEffect(() => {
    if (!isPaused && slides.length > 0) {
      intervalRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 3000);
    }
    return () => intervalRef.current && clearInterval(intervalRef.current);
  }, [isPaused, slides.length]);

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (diff > 50) handleNext(); // Swipe Left
    if (diff < -50) handlePrev(); // Swipe Right
  };

  const handleMouseDown = () => {
    setIsPaused(true);
    intervalRef.current && clearInterval(intervalRef.current);
  };

  const handleMouseUp = () => {
    setIsPaused(false);
  };

  useEffect(() => {
    getAllBanner()
      .then((res) => {
        setSlides(res.data.filter((s) => s.name.includes("Slide")));
        setMainSlide(res.data.find((s) => s._id === "682e1daaf88fa6596ba0c57a"));
      })
      .catch((err) => console.log(err));
  }, []);

  // if (!mainSlide || slides.length === 0) {
  //   return <div className="text-center py-10">Loading...</div>;
  // }

  const Skeleton = ({ className }) => (
    <div
      className={`bg-gray-300 animate-pulse ${className}`}
    />
  );

  return (
    <div className="w-full justify-between mx-auto flex flex-col md:flex-row gap-2">
      {/* Main Image */}
      <div className="w-full md:w-[65%] h-full">
         {mainSlide ? (
          <img
            src={mainSlide?.image}
            alt={mainSlide?.name}
            className="w-full h-auto"
          />
        ) : (
          <Skeleton className="w-full h-64 md:h-[400px] rounded" />
        )}
      </div>

      {/* Slider */}
      <div className="relative w-full md:w-[34.9%] overflow-hidden">
        {slides.length > 0 ? (
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {slides.map((slide) => (
            <div key={slide._id} className="w-full h-auto flex-shrink-0">
              <img
                src={slide.image}
                alt={slide.name}
                className="w-full h-auto"
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
                onTouchStart={handleMouseDown}
                onTouchEnd={handleMouseUp}
                loading="lazy"
              />
            </div>
          ))}
        </div>
        ) : (
          // Skeleton loader for slider
          <div className="flex space-x-2">
            {[1, 2, 3].map((i) => (
              <Skeleton
                key={i}
                className="w-full rounded  h-64 md:h-[400px] flex-shrink-0"
              />
            ))}
          </div>
        )}

        {/* Navigation Buttons */}
        <button
          onClick={handlePrev}
          aria-label="Previous Slide"
          className="absolute top-1/2 left-2 md:left-4 transform -translate-y-1/2 rounded-full p-2 md:p-3 bg-white/80 hover:bg-white shadow"
        >
          &#9664;
        </button>

        <button
          onClick={handleNext}
          aria-label="Next Slide"
          className="absolute top-1/2 right-2 md:right-4 transform -translate-y-1/2 rounded-full p-2 md:p-3 bg-white/80 hover:bg-white shadow"
        >
          &#9654;
        </button>

        {/* Indicators */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`h-2 w-2 md:h-3 md:w-3 rounded-full transition-all duration-300 ${
                index === currentSlide ? "bg-white w-6" : "bg-gray-600"
              }`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
